export default __webpack_public_path__ + "static/media/dakada-tower.fdf69a15.jpeg";